import React from 'react';
import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

// shows max 2 pages on the left and max 2 pages on the right
// it addition it shows Prev and Next links
function Pagination(props) {
    const current = props.currentPage;  // starts with 1
    const total = props.totalPages;
    if (current > total) {
        return null;
    }
    if (total < 2) {
        return null;
    }

    const maxPageNum = total;
    const minPageNum = 1;
    let hasPrev = () => {
        return current - 1 >= minPageNum;
    }
    let hasOneBeforePrev = () => {
        return current - 2 >= minPageNum;
    }
    let hasNext = () => {
        return current + 1 <= maxPageNum;
    }
    let hasOneAfterNext = () => {
        return current + 2 <= maxPageNum;
    }

    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination">
                <li className={hasPrev() ? "page-item" : "page-item disabled"}>
                    <a className="page-link" href={`?page=${current - 1}`}>Previous</a>
                </li>
                {hasOneBeforePrev() ?
                    <li className="page-item">
                        <a className="page-link" href={`?page=${current - 2}`}>{current - 2}</a>
                    </li> : null}
                {hasPrev() ?
                    <li className="page-item">
                        <a className="page-link" href={`?page=${current - 1}`}>{current - 1}</a>
                    </li> : null}

                <li className="page-item active"><a className="page-link" href={`?page=${current}`}>{current}</a></li>

                {hasNext() ?
                    <li className="page-item">
                        <a className="page-link" href={`?page=${current + 1}`}>{current + 1}</a>
                    </li> : null}
                {hasOneAfterNext() ?
                    <li className="page-item">
                        <a className="page-link" href={`?page=${current + 2}`}>{current + 2}</a>
                    </li> : null}
                <li className={hasNext() ? "page-item" : "page-item disabled"}>
                    <a className="page-link" href={`?page=${current + 1}`}>Next</a>
                </li>
            </ul>
        </nav>
    )
}

export default class Billing extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(this.props.location.search);
        const fromDate = params.get('from-date');
        const toDate = params.get('to-date');
        const trailerName = params.get('trailer-name');
        this.state = {
            alert: '',
            startDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : '',
            endDate: toDate ? moment(toDate).format('YYYY-MM-DD') : '',
            trailerName: trailerName ? trailerName : '',
            records: [],
            currentPage: 1,
            totalPages: 1,
            totalRecords: 0,
        }
    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        return (
            <div className="container-fluid">

                <Row className="mx-0">
                        <h4 className="mt-4">Newgistics billing <small className="text-muted">[{this.state.totalRecords}]</small></h4>
                </Row>

                <Form onSubmit={this.handleFilterByTrailerNameSubmit} className="ml-3">
                    <Form.Group as={Row}>
                        <Form.Label column sm={1}>Trailer name: </Form.Label>

                        <Col>
                            <Form.Control
                                name="trailerName"
                                value={this.state.trailerName}
                                onChange={this.handleChange}
                            />
                        </Col>

                        <Col>
                            <Button variant="outline-success" type="submit">Filter</Button>
                        </Col>
                    </Form.Group>
                </Form>

                <Form onSubmit={this.handleFilterByDateSubmit} className="ml-3">
                    <Form.Group as={Row}>
                        <Form.Label column sm={1}>From: </Form.Label>

                        <Col>
                            <Form.Control
                                type="date"
                                name="startDate"
                                value={this.state.startDate}
                                onChange={this.handleChange}
                            />
                        </Col>

                        <Form.Label column sm={1}>To: </Form.Label>
                        <Col>
                            <Form.Control
                                type="date"
                                name="endDate"
                                value={this.state.endDate}
                                onChange={this.handleChange}
                            />
                        </Col>

                        <Col>
                            <Button variant="outline-success" type="submit">Filter</Button>
                        </Col>
                    </Form.Group>

                </Form>

                {this.state.records.length > 0 &&
                <Table>
                    <thead>
                    <tr>
                        <th>USPS barcode</th>
                        <th>Manifest</th>
                        <th>Account number</th>
                        <th>Account name</th>
                        <th>Induction date</th>
                        <th>Rated date</th>
                        <th>Tracking number</th>
                        <th>Reference number</th>
                        <th>Entry facility zip</th>
                        <th>Ship to zip</th>
                        <th>Service name</th>
                        <th>Trailer name</th>
                        <th>Weight</th>
                        <th>Zone</th>
                        <th>Balloon flag</th>
                        <th>Oversize flag</th>
                        <th>Non machinable flag</th>
                        <th>Delivery conf fee</th>
                        <th>Postage total</th>
                        <th>Service charges</th>
                        <th>Fuel surcharge</th>
                        <th>Total</th>
                        <th>Cust ref num</th>
                        <th>Created at</th>
                    </tr>
                    </thead>
                    {
                        this.state.records.map((r, index) => {
                            return (
                                <tbody key={index}>
                                <tr>
                                    <td><a href={"packages/" + r.package_id}>{r.usps_barcode}</a></td>
                                    <td><a href={"manifests/" + r.manifest_id}>{r.mawb}</a></td>
                                    <td>{r.account_number}</td>
                                    <td>{r.account_name}</td>
                                    <td>{r.induction_date}</td>
                                    <td>{r.rated_date}</td>
                                    <td>{r.tracking_number}</td>
                                    <td>{r.reference_number}</td>
                                    <td>{r.entry_facility_zip}</td>
                                    <td>{r.ship_to_zip}</td>
                                    <td>{r.service_name}</td>
                                    <td>{r.trailer_name}</td>
                                    <td>{r.weight}</td>
                                    <td>{r.zone}</td>
                                    <td>{r.balloon_flag}</td>
                                    <td>{r.oversize_flag}</td>
                                    <td>{r.non_machinable_flag}</td>
                                    <td>{r.delivery_conf_fee}</td>
                                    <td>{r.postage_total}</td>
                                    <td>{r.service_charges}</td>
                                    <td>{r.fuel_surcharge}</td>
                                    <td>{r.total}</td>
                                    <td>{r.cust_ref_num}</td>
                                    <td>{moment(r.created_at).format('MMMM Do YYYY h:mm:ss a')}</td>
                                </tr>
                                </tbody>
                            );
                        })
                    }
                </Table>
                }

                <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages}/>

            </div>
        );
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
    };

    handleFilterByTrailerNameSubmit = (e) => {
        e.preventDefault();
        window.location.href = '/billing?trailer-name=' + encodeURIComponent(this.state.trailerName);
    }

    handleFilterByDateSubmit = (e) => {
        e.preventDefault();

        let startDate = '';
        let endDate = '';
        if (this.state.startDate) {
            startDate = moment(this.state.startDate).utc().format();
        }
        if (this.state.endDate) {
            endDate = moment(this.state.endDate).add(1, 'days').utc().format();
        }
        let query = '';
        if (startDate !== '' && endDate !== '') {
            query = encodeURI(`from-date=${startDate}&to-date=${endDate}`);
        } else if (startDate !== '' && endDate === '') {
            query = encodeURI(`from-date=${startDate}`);
        } else if (startDate === '' && endDate !== '') {
            query = encodeURI(`to-date=${endDate}`);
        }
        let baseUrl = '/billing';
        window.location.href = query === '' ? baseUrl : baseUrl + '?' + query;
    };

    componentDidMount() {
        const url = '/api/v1/admin/billing' + this.props.location.search
        JwtClient.get(url)
            .then(response => {
                if (response.data.result) {
                    this.setState({
                        records: response.data.result,
                        currentPage: Number(response.data.current_page),
                        totalPages: Number(response.data.total_pages),
                        totalRecords: Number(response.data.total_records),
                    });
                } else {
                    this.setState({records: []});
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching billing, status: ' + error.response.status});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    }
}
